import { createReducer, on } from '@ngrx/store';

import {
    seReportSetCurrentExaminationIdsEcg,
    seReportSetCurrentExaminationIdsVisit,
    seReportSetIsModified,
    seReportSetIsPreview,
    seReportSetKeyImages,
    seReportSetPatientId,
    seReportSetImagesPerRowInPlaceholder,
    seReportSetIsReadonly,
    seReportImportConclusions,
    seReportSetExaminationStudies
} from './report.actions';
import { seReportInitialState } from './report.state';

export const seReportReducer = createReducer(
    seReportInitialState,
    on(seReportSetCurrentExaminationIdsEcg, (state, { ids }) => ({
        ...state,
        currentExaminationIds: { ...state.currentExaminationIds, ecg: ids },
    })),
    on(seReportSetCurrentExaminationIdsVisit, (state, { ids }) => ({
        ...state,
        currentExaminationIds: { ...state.currentExaminationIds, visit: ids },
    })),
    on(seReportSetIsModified, (state, { isModified }) => ({ ...state, isModified })),
    on(seReportSetIsPreview, (state, { isPreview }) => ({ ...state, isPreview })),
    on(seReportSetIsReadonly, (state, { isReadonly }) => ({ ...state, isReadonly })),
    on(seReportSetKeyImages, (state, { keyImages }) => ({ ...state, keyImages })),
    on(seReportSetPatientId, (state, { patientId }) => ({ ...state, patientId })),
    on(seReportSetImagesPerRowInPlaceholder, (state, { imagesPerRowInPlaceholder }) => ({
        ...state,
        imagesPerRowInPlaceholder,
    })),
    on(seReportImportConclusions, (state, { conclusions }) => ({ ...state, conclusions })),
    on(seReportSetExaminationStudies, (state, { examinationStudies }) => ({
        ...state,
        examinationStudies,
    })),
);
